<template>
	<div class="con">
		<div>
			<van-divider dashed class="head-title">共有<span>{{list.length}}</span>名</van-divider>
		</div>
		<div class="list" v-if="list.length != ''">
			<div v-for="(item,index) in list" class="list-disp" @click="toDeta(index)">
				<img class="list-left-img" src="../assets/doctor.png" v-if="item.HEADPORTRAITURL == '' || item.HEADPORTRAITURL == undefined" />
				<!--<img :src="'data:image/png;base64,'+item.HEAD_PORTRAIT" alt="" v-else/>-->
				<img :src="item.HEADPORTRAITURL" alt="" v-else />
				<div class="list-right">
					<div class="list-name-disp">
						<div class="text">{{item.YGXM}}</div>
						<span>收藏</span>
					</div>

					<div class="list-right-have">{{item.JBMC}}</div>
					<!--<div class="list-right-have"><span>{{item.accepts}}</span>次接诊</div>-->
				</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == false">
			<img src="../assets/404.gif" />
			<div class="no-text">无收藏医生~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'collection',
		data() {
			return {
				msg: '通讯录',
				showIndex: 0,
				list: [],
				cardUserInfo: '',
				noImgShow: true,
			}
		},
		methods: {
			//获取收藏医生列表
			GetGyYgdmKsdm() {
				this.$store.commit('Load', true)
				this.$Axios.Get('/collect/getCollectDoctorList?brid=' + this.cardUserInfo.brid + '&bahm=' + this.cardUserInfo.bahm, null).then(res => {
					this.$store.commit('Load', false)
					console.log(res)
					if (res.code == 0) {
						if (res.msg.length != 0) {
							this.noImgShow = true;
							this.list = res.msg;
						} else {
							this.noImgShow = false;
						}

					} else {
						this.noImgShow = false;
					}
				}).catch(err => {
					this.$toast("网络出错")
					this.$store.commit('Load', false)
					this.noImgShow = false;
					console.log(err)
				})
			},
			//收藏医生详情
			toDeta(e) {
				console.log(e)
				let list = JSON.stringify(this.list[e]);
				this.$router.push({
					path: '/collectionDeta',
					query: {
						list: list
					}
				})
			},
		},
		mounted() {
			this.GetGyYgdmKsdm();
		},
		created() {
			
			if (localStorage.getItem('cardUserInfo') == '') {
				
			}else{
				this.cardUserInfo = JSON.parse(localStorage.getItem('cardUserInfo'))
			}
		}
	}
</script>

<style scoped>
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}

	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;

	}

	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}

	.head-title {
		font-size: 16px;
	}

	.head-title span {
		color: #27BEC4;
		font-size: 18px;
		font-weight: 700;
	}

	.list {
		flex: 1;
		overflow-y: auto;
	}

	.list-left-img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		overflow: hidden;
	}

	.list-disp {
		display: flex;
		align-items: center;
		background-color: #fff;
		padding: 15px 10px;
		margin: 0 10px;
		border-bottom: 1px solid #ccc;

	}

	.list-disp img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		overflow: hidden;
	}

	.list-right {
		margin-left: 10px;
		width: 80%;
		font-size: 15px;
		font-weight: 700;
	}

	.list-right-have {
		margin-top: 5px;
		color: #999;
		font-weight: 500;
	}

	.list-right-have span {
		font-weight: 700;
		color: #000000;
	}

	.list-name-disp {
		display: flex;
		justify-content: space-between;
	}

	.list-name-disp span {
		font-size: 12px;
		color: #999;
	}

	.text {
		color: #000000;
		font-size: 17px;
	}
</style>
